import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'

export default function useBadgeProducts(badgeId?: string) {
  const initialFilters = {
    page: 1,
    limit: 30,
    brand_id: '',
    category_id: '',
    search: '',
    sort_by: 'name/1',
  }
  const Api = useApi()
  const {filters, setMultipleFilters, onSearch, onSortingChange, onPageChange} = useFilters(
    initialFilters,
    {sortType: 'number'}
  )
  const {data: response, isFetching} = Api.useGetQuery(
    badgeId ? `/products/product-badges/${badgeId}/product-details` : '',
    {
      queryId: badgeId ? `badge-products-${badgeId}` : undefined,
      filters,
    }
  )

  const onChangeBrandFilter = (brands: string[]) => {
    setMultipleFilters({brand_id: brands?.map((brand: any) => brand.value)?.join(',')})
  }
  const onChangeCategoryFilter = (categories: string[]) => {
    setMultipleFilters({category_id: categories?.map((category: any) => category.value)?.join(',')})
  }

  return {
    badgeProducts: response?.data || [],
    pagination: response?.pagination,
    totalCount: response?.meta?.total_count,
    isLoading: isFetching,
    filters,
    onSortingChange,
    onSearch,
    onPageChange,
    onChangeBrandFilter,
    onChangeCategoryFilter,
  }
}
